/**
 * 行政管理（administrationManagement）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/OAoffice/administrationManagement/ 下
 *          PersonalManagement/schedule（人事-日程/日历）、WorkRecords（工作汇报：日报/周报/
 *          月报/年报/抄送我的）、WorkplaceManagement（工作台配置）
 * 术语：人事=Personnel，日程=Schedule，日历=Calendar，汇报=Report，
 *       抄送=CC，工作台=Workplace，模块=Module，流程=Process
 */
export default {
  // 通用词（与 en-US.js 保持一致，模块内自包含）
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '提示': 'Notice',
  '新增': 'Add',
  '删除': 'Delete',
  '编辑': 'Edit',
  '详情': 'Details',
  '更多': 'More',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '操作': 'Action',
  '创建时间': 'Created At',
  '已选择 {count} 项': '{count} items selected',
  '确定删除吗?': 'Are you sure you want to delete?',
  '无图片': 'No Image',
  '无文件': 'No File',
  '下载': 'Download',
  '导出': 'Export',
  '导入': 'Import',
  '提交': 'Submit',
  // 日程/日历（PersonalManagement/schedule）
  'OA日程表': 'OA Schedule',
  '新建日程': 'New Schedule',
  '今天': 'Today',
  '月': 'Month',
  '周': 'Week',
  '日': 'Day',
  '周列表': 'Week List',
  '查看更多': 'Show More',
  '找日程': 'Find Schedule',
  '过去时间不能进行新增!': 'Cannot add schedules in the past!',
  '是否真的要删除日历!': 'Are you sure you want to delete this calendar!',
  '是否真的要删除日程!': 'Are you sure you want to delete this schedule!',
  '请设置calurl.delete属性!': 'Please configure the calurl.delete property!',
  '请设置url.delete属性!': 'Please configure the url.delete property!',
  // 字段
  '名称': 'Name',
  '颜色': 'Color',
  '日历类型': 'Calendar Type',
  '所属人': 'Owner',
  '参与人': 'Participant',
  '备注': 'Remark',
  '标题': 'Title',
  '内容': 'Content',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '是否全天': 'All Day',
  '优先级': 'Priority',
  '提前提醒时间': 'Advance Reminder Time',
  '提醒方式': 'Reminder Method',
  '地点': 'Location',
  '来源': 'Source',
  '链接': 'Link',
  // 表单 placeholder
  '请输入名称': 'Please enter name',
  '请选择日历类型': 'Please select calendar type',
  '请输入备注': 'Please enter remark',
  '请输入标题': 'Please enter the title',
  '请输入内容': 'Please enter content',
  '请选择开始时间': 'Please select start time',
  '请选择结束时间': 'Please select end time',
  '请选择是否全天': 'Please select all-day or not',
  '请选择优先级': 'Please select priority',
  '请选择提前提醒时间': 'Please select advance reminder time',
  '请输入地点': 'Please enter the location',
  // 表单校验/提醒方式
  '请输入名称!': 'Please enter the name!',
  '请输入颜色!': 'Please select a color!',
  '请选择日历类型!': 'Please select calendar type!',
  '请输入标题!': 'Please enter the title!',
  '请选择开始时间!': 'Please select the start time!',
  '请选择结束时间!': 'Please select the end time!',
  '请选择是否全天!': 'Please select all-day or not!',
  '消息提醒': 'Message Notification',
  '目前只支持消息提醒!': 'Currently only message notification is supported!',
  // 工作汇报（WorkRecords：日报/周报/月报/年报/抄送我的）
  '工作日期': 'Work Date',
  '工作内容': 'Work Content',
  '抄送人员': 'CC Recipients',
  '工作人': 'Worker',
  '提交时间': 'Submitted At',
  '汇报类型': 'Report Type',
  '日报': 'Daily Report',
  '周报': 'Weekly Report',
  '月报': 'Monthly Report',
  '年报': 'Annual Report',
  '工作开始时间': 'Work Start Time',
  '工作结束时间': 'Work End Time',
  '附件': 'Attachment',
  '工作开始日期': 'Work Start Date',
  '工作结束日期': 'Work End Date',
  '请选择工作开始日期': 'Please select work start date',
  '请选择工作结束日期': 'Please select work end date',
  '请选择工作人员': 'Please select the worker',
  '请选择所属部门': 'Please select the department',
  // 工作台配置（WorkplaceManagement）
  '模块名称': 'Module Name',
  '模块描述': 'Module Description',
  '流程名称': 'Process Name',
  '流程选择': 'Process Selection',
  '请输入模块名称': 'Please enter module name',
  '请选择流程': 'Please select a process',
  '请输入模块描述': 'Please enter module description',
  '请选择工作日期': 'Please select work date'
}
